import { NavLink, useLocation } from 'react-router-dom';

/**
 * One navigation for every demo screen.
 *
 * It used to live on the two home screens only, so stepping into any scene —
 * the journey, the world map, the hall — left the visitor with no visible way
 * back except the header logo, which nobody reads as a back button.
 *
 * The targets are demo routes on purpose: the app's own navigation points at
 * guarded routes that would bounce a signed-out visitor to the login screen.
 */

export interface DemoNavItem { id: string; label: string; glyph: string; to: string; center?: boolean }

export const demoChildNav: DemoNavItem[] = [
  { id: 'home', label: '홈', glyph: '🏠', to: '/demo/child' },
  { id: 'explore', label: '탐험', glyph: '🧭', to: '/demo/child/journey' },
  { id: 'snows', label: '도우미', glyph: '', to: '/demo/child/journey', center: true },
  { id: 'village', label: '마을', glyph: '🏘️', to: '/demo/world' },
  { id: 'collection', label: '컬렉션', glyph: '🏅', to: '/demo/hall' },
];

export const demoParentNav: DemoNavItem[] = [
  { id: 'check', label: '확인', glyph: '✅', to: '/demo/parent' },
  { id: 'growth', label: '성장', glyph: '📈', to: '/demo/report' },
  { id: 'family', label: '가족', glyph: '💬', to: '/demo/family' },
  { id: 'passport', label: '패스포트', glyph: '🛂', to: '/demo/passport' },
];

/** Screens a parent would be looking at; everything else reads as the child side. */
const PARENT_PREFIXES = ['/demo/parent', '/demo/report', '/demo/passport', '/demo/family'];

export function demoNavFor(pathname: string): DemoNavItem[] | null {
  // The entry screen is the chooser itself, so it carries no navigation.
  if (pathname === '/demo' || !pathname.startsWith('/demo')) return null;
  return PARENT_PREFIXES.some((prefix) => pathname.startsWith(prefix)) ? demoParentNav : demoChildNav;
}

export function DemoBottomNav({ items }: { items: DemoNavItem[] }) {
  const { pathname } = useLocation();
  return <nav className="demo-bottom-nav-2-24" aria-label="데모 메뉴">
    {items.map((item) => (
      <NavLink key={item.id} to={item.to} className={pathname === item.to ? 'active' : ''} end>
        {item.center
          ? <span className="demo-nav-orb-2-24"><img src="/assets/characters/snows/snows_wave_v1.png" alt=""/></span>
          : <span className="demo-nav-glyph-2-24" aria-hidden="true">{item.glyph}</span>}
        <small>{item.label}</small>
      </NavLink>
    ))}
  </nav>;
}
